<template>
  <div class="shadow overflow-hidden sm:rounded-lg">
    <div class="px-4 py-5 border-gray-200 border rounded-t-lg bg-gray-50">
      <h3 class="text-lg leading-6 font-medium text-vice-teal-700 ml-2" v-if="$slots.header">
        <slot name="header"></slot>
      </h3>
    </div>
    <div class="px-4 py-2 border-gray-200 border border-t-0 bg-gray-50">
      <h3
        class="text-xs leading-6 uppercase tracking-widest font-normal text-vice-dark-grey ml-2"
        v-if="$slots.subheader"
      >
        <slot name="subheader"></slot>
      </h3>
    </div>
    <div class="bg-white border border-t-0" v-if="$slots.content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReflectionTableCard',
};
</script>

<style scoped></style>
